import React, { useState } from "react";
import Logo from "../../../assets/logo/logo2.png";

const TemplatePDFReportViewCompanyL = ({ data }) => {
  const [datacompanypdf] = useState(data);

  const styles = {
    TittlePDF: {
      color: "#56b599",
      padding: "10px 0px",
      fontsize: "1.6em",
      textalign: "left",
      textAlign: "initial",
      borderBottom: "2px solid",
    },
    boxinfotriPDF: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-around",
      flexWrap: "wrap",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    boxinfotriPDFlast: {
      width: "100%",
      borderBottom: "0.5px dashed #d1d1d1",
      padding: "10px 0px",
    },
    divlabelspam: {
      color: "#625e5d",
      fontSize: "18px",
      fontWeight: "600",
      padding: "25px 0px",
      width: "33%",
      textAlign: "initial",
    },
    divlabelspamlast: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "25px 0px",
      width: "100%",
      textAlign: "initial",
    },
    divlabelspameconomic: {
      color: "#224268",
      fontSize: "18px",
      fontWeight: "600",
      padding: "20px 0px",
      width: "50%",
      textAlign: "initial",
    },
    pagefrompage: {
      margin: "30px 10px 0px 10px",
    },
    pagefrompagemax2: {
      margin: "60px 10px 0px 10px",
    },
    pagefrompageemployer: {
      margin: "140px 10px 0px 10px",
    },
    pagefrompagepdf2: {
      margin: "60px 10px 0px 10px",
    },
    infopdf: {
      color: "#56b599",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
    },
    infopdflast: {
      color: "#56b599",
      fontSize: "18px",
      fontWeight: "500",
      margin: "0px 10px",
      width: "100%",
    },
    tablebackground: {
      borderCollapse: "collapse",
      padding: "10px",
      border: "1px solid #ddd",
      width: "100%",
    },
    headertable: {
      color: "#737373",
      backgroundColor: "#f5f5f5",
      padding: "10px",
      border: "1px solid #ddd",
    },
    headerinfotableabm: {
      backgroundColor: "white",
      border: "1px solid #ddd",
      padding: "10px",
      color: "#737373",
    },

    boxnumbertablevarmatrx: {
      width: "25px",
      height: "25px",
    },

    headerinfotableabmnumber: {
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #ddd",
    },

    lastcompanyinfo: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      borderBottom: "0.5px dashed rgb(209, 209, 209)",
      padding: "10px 0px",
      flexWrap: "wrap",
    },

    pagefrompagevarmatrx: {
      margin: "500px 10px 0px 10px",
    },

    header: {
      backgroundColor: "white",
      borderBotton: "1px solid #d1d1d1",
      boxShadow: "0px 10px 5px -3px rgba(0, 0, 0, 0.1)",
      padding: "10px",
      margin: "10px 0px",
      textAlign: "initial",
    },

    logo: {
      width: "200px",
      height: "70px",
    },

    footer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      margin: "30px 0px 0px 0px",
      borderTop: "1px solid #d1d1d1",
    },
    footertext: {
      fontSize: "12px",
      color: "#929292",
    },
    logofooter: {
      width: "90px",
      height: "30px",
    },
  };

  const riskColors = {
    1: "#5fbf49",
    2: "#f6e502",
    3: "#f49e01",
    4: "#ff7089",
    5: "red",
  };

  // Predefinir los valores para "Factor de riesgo" y "Variable"
  const combinedValues = data
    ? [
        {
          factorRiesgo: "Ingresos Legales",
          variable: "Monto Transaccional Anual",
          valorObtenido: data.EconomicInformationCompany.IncomeOfLegalPerson,
          riesgoObtenido: data.MDRCompany.IncomeLegal.value,
        },
        {
          factorRiesgo: "Ubicacion - Zona Geografica",
          variable: "Codigo Postal - Localidad",
          valorObtenido: data.postalCode + "," + data.location,
          riesgoObtenido: data.MDRCompany.GeographicLocation.value,
        },
        {
          factorRiesgo: "Actividad que desarrolla",
          variable: "Actividades AFIP",
          valorObtenido: data.ActivityBeingCarriedOut,
          riesgoObtenido: data.MDRCompany.ActivityBeingCarriedOut.value,
        },
        {
          factorRiesgo: "Antigüedad en la actividad",
          variable: "En REPSAL",
          valorObtenido: data.age + " años",
          riesgoObtenido: data.MDRCompany.ActivitySeniority.value,
        },
        {
          factorRiesgo: "Tipo de operatoria",
          variable: "En REPSAL",
          valorObtenido: data.RelationshipWithMutualCompany.typeOfCredit,
          riesgoObtenido: data.MDRCompany.TypeOperation.value,
        },
        {
          factorRiesgo: "Tipo de cliente",
          variable: "Persona Humana o Jurídica",
          valorObtenido: data.typeCustomer,
          riesgoObtenido: data.MDRCompany.TypeCustomer.value,
        },
        {
          factorRiesgo: "Presentación de documentación",
          variable: "Documentación",
          valorObtenido: data.MDRCompany.Documentation.data,
          riesgoObtenido: data.MDRCompany.Documentation.value,
        },
        {
          factorRiesgo: "Canal",
          variable: "Físico o Digital",
          valorObtenido: data.MDRCompany.Canal.data,
          riesgoObtenido: data.MDRCompany.Canal.value,
        },
      ]
    : [];

  const typeRelationMutual = () => {
    if (datacompanypdf.RelationshipWithMutualCompany.relation === "Proveedor") {
      return (
        <div style={styles.pagefrompage}>
          <div>
            <h2 style={styles.TittlePDF}>Relación con la mutual</h2>
          </div>
          <div>
            <div style={styles.lastcompanyinfo}>
              <div style={styles.divlabelspameconomic}>
                <label>Relación:</label>
                <span style={styles.infopdf}>
                  {datacompanypdf.RelationshipWithMutualCompany.relation}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div style={styles.pagefrompage}>
          <div>
            <h2 style={styles.TittlePDF}>Relación con la mutual</h2>
          </div>
          <div>
            <div style={styles.lastcompanyinfo}>
              <div style={styles.divlabelspameconomic}>
                <label>Relación:</label>
                <span style={styles.infopdf}>
                  {datacompanypdf.RelationshipWithMutualCompany.relation}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <img src={Logo} style={styles.logo} alt="Logo" />
      </div>
      <div style={styles.pagefrompagemax2}>
        <div>
          <h2 style={styles.TittlePDF}>Información Personal</h2>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Razón Social:</label>
            <span style={styles.infopdf}>{datacompanypdf.companyName}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>CUIT:</label>
            <span style={styles.infopdf}>{datacompanypdf.cuit}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Años:</label>
            <span style={styles.infopdf}>{datacompanypdf.age}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Teléfono:</label>
            <span style={styles.infopdf}>{datacompanypdf.phone}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Correo electrónico:</label>
            <span style={styles.infopdf}>{datacompanypdf.email}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Codigo de actividad laboral:</label>
            <span style={styles.infopdf}>
              {datacompanypdf.codeOfWorkActivity}
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Calle:</label>
            <span style={styles.infopdf}>{datacompanypdf.street}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Numero:</label>
            <span style={styles.infopdf}>{datacompanypdf.numberStreet}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Codigo Postal:</label>
            <span style={styles.infopdf}>{datacompanypdf.postalCode}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Localidad:</label>
            <span style={styles.infopdf}>{datacompanypdf.location}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Provincia:</label>
            <span style={styles.infopdf}>{datacompanypdf.province}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Pais de residencia:</label>
            <span style={styles.infopdf}>{datacompanypdf.nacionality}</span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspam}>
            <label>Piso:</label>
            <span style={styles.infopdf}>{datacompanypdf.floor}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Departamento:</label>
            <span style={styles.infopdf}>{datacompanypdf.apartment}</span>
          </div>
          <div style={styles.divlabelspam}>
            <label>Codigo Postal:</label>
            <span style={styles.infopdf}>{datacompanypdf.postalCode}</span>
          </div>
        </div>
        <div style={styles.lastcompanyinfo}>
          <div style={styles.divlabelspam}>
            <label>Actividad que desarrolla:</label>
            <span style={styles.infopdf}>
              {datacompanypdf.ActivityBeingCarriedOut}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompagemax2}>
        <div>
          <h2 style={styles.TittlePDF}>Información Economica</h2>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Monto Transaccional Anual:</label>
            <span style={styles.infopdf}>
              {datacompanypdf.EconomicInformationCompany.IncomeOfLegalPerson}
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Total de endeudamiento del sistema financiero:</label>
            <span style={styles.infopdf}>
              {
                datacompanypdf.EconomicInformationCompany
                  .total_indebtedness_of_the_financial_system
              }
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDF}>
          <div style={styles.divlabelspameconomic}>
            <label>Total de compromiso mensual sistema financiero:</label>
            <span style={styles.infopdf}>
              {
                datacompanypdf.EconomicInformationCompany
                  .total_monthly_commitment_of_the_financial_system
              }
            </span>
          </div>
          <div style={styles.divlabelspameconomic}>
            <label>Situación vigente ante BCRA:</label>
            <span style={styles.infopdf}>
              {
                datacompanypdf.EconomicInformationCompany
                  .current_status_with_BCRA
              }
            </span>
          </div>
        </div>
      </div>
      {typeRelationMutual()}
      <div style={styles.pagefrompagepdf2}>
        <div>
          <h2 style={styles.TittlePDF}>Informacion PEP</h2>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspam}>
            <label>Es políticamente expuesto:</label>
            <span style={styles.infopdf}>
              {datacompanypdf.PoliticalInformationCompany.politicallyExposed}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>Información Terrorismo</h2>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspamlast}>
            <label>Verificación de terrorismo (DNI):</label>
            <span style={styles.infopdf}>
              {datacompanypdf.PoliticalInformationCompany.terrorismVerification}
            </span>
          </div>
        </div>
        <div style={styles.boxinfotriPDFlast}>
          <div style={styles.divlabelspamlast}>
            <label>Resultado:</label>
            <span style={styles.infopdflast}>
              {datacompanypdf.PoliticalInformationCompany.verification}
            </span>
          </div>
        </div>
      </div>
      <div style={styles.pagefrompage}>
        <div>
          <h2 style={styles.TittlePDF}>ABM de documentos</h2>
        </div>
        {!datacompanypdf.ABMOfDocumentCompany ? (
          <p>No hay ABM's cargados.</p>
        ) : (
          <div>
            <table style={styles.tablebackground}>
              <thead>
                <tr>
                  <th style={styles.headertable}>Tipo de archivo</th>
                  <th style={styles.headertable}>Descripcion</th>
                  <th style={styles.headertable}>Fecha de creación</th>
                </tr>
              </thead>
              <tbody>
                {datacompanypdf.ABMOfDocumentCompany.map((item, index) => (
                  <tr key={index}>
                    <td style={styles.headerinfotableabm}>
                      {item.typeDocument}
                    </td>
                    <td style={styles.headerinfotableabm}>
                      {item.description}
                    </td>
                    <td style={styles.headerinfotableabm}>{item.createAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div style={styles.pagefrompagevarmatrx}>
        <div>
          <h2 style={styles.TittlePDF}>Matriz de Variables</h2>
        </div>
        <table style={styles.tablebackground}>
          <thead>
            <tr>
              <th style={styles.headertable}>Factor de riesgo</th>
              <th style={styles.headertable}>Variable</th>
              <th style={styles.headertable}>Valor obtenido</th>
              <th style={styles.headertable}>Riesgo obtenido</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td style={styles.headerinfotableabm}>{item.factorRiesgo}</td>
                <td style={styles.headerinfotableabm}>{item.variable}</td>
                <td style={styles.headerinfotableabm}>{item.valorObtenido}</td>
                <td style={styles.headerinfotableabmnumber}>
                  <div
                    style={{
                      width: "25px",
                      height: "25px",
                      margin: "auto",
                      color: "white",
                      fontWeight: "600",
                      backgroundColor: riskColors[item.riesgoObtenido],
                    }}
                  >
                    <p style={{ padding: "4px 0px 0px 7px", margin: "auto" }}>
                      {item.riesgoObtenido}
                    </p>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={styles.footer}>
        <div>
          <p style={styles.footertext}>
            © 2024. Todos los derechos reservados.
          </p>
        </div>
        <div>
          <img style={styles.logofooter} src={Logo} alt="Logo" />
        </div>
      </div>
    </div>
  );
};

export default TemplatePDFReportViewCompanyL;
